<!-- used to display info about project like tags, comments, collaborators, saved items
In (UI) discovery tool-> overview-> open any active project-> navigation pan in left
-->
<template>
  <v-col
    :md="!this.minify ? 3 : undefined"
    class="px-0 py-0 fillHeight"
    :style="minify ? 'max-width: 30px' : 'width: inherit'"
  >
    <v-card class="leftContentDrawer" elevation="0" color="#58e2c2">
      <v-navigation-drawer
        :width="drawerWidth"
        miniVariantWidth="30"
        v-model="drawer"
        floating
        :mini-variant="minify"
        hide-overlay
        color="#58e2c2"
        stateless
        class="leftContentDrawerData minHeight"
        :data-test-id="`${dataTestId}`"
      >
        <!-- :height="setheight" -->
        <v-btn
          small
          :ripple="false"
          @click.stop="toggleLeftNavigationPan"
          absolute
          fab
          color="#58e2c2"
          :style="minify ? 'margin-left: -22px' : 'right: -20px'"
          class="slideOnOffBtn"
          data-test-id="discovery-sidebar__toggle-btn"
        >
          <v-icon class="white--text">
            {{ minify ? 'chevron_right' : 'chevron_left' }}
          </v-icon>
        </v-btn>

        <div v-if="!minify" class="paddingR34" id="leftNav">
          <div class="container">
            <template v-if="!projectDetails">
              <v-skeleton-loader
                class="mb-4"
                max-width="300"
                type="heading, paragraph@3"
                :loading="true"
              ></v-skeleton-loader>
              <v-spacer></v-spacer>
              <v-skeleton-loader
                class="mb-4"
                max-width="300"
                type="heading, paragraph@2"
                :loading="true"
              ></v-skeleton-loader>
              <v-spacer></v-spacer>
              <v-skeleton-loader
                class="mb-4"
                max-width="300"
                type="heading, text@5"
                :loading="true"
              ></v-skeleton-loader>
            </template>
            <template v-else>
              <ProjectArchivedItemsSummary :projectDetails="projectDetails" :dataTestId="`${dataTestId}__project-saved-items-section`"/>

              <hr color="#fff" class="mt-2 mb-3" />
              <ProjectTags
                :projectDetails="projectDetails"
                :allTags="allTags"
                :dataTestId="`${dataTestId}__project-tag-section`"
              />

              <hr color="#fff" class="mt-2 mb-3" />

              <ProjectCollabList
                :projectDetails="projectDetails"
                :collaboratorsList="collaboratorsList"
                :allUserObj="allUserObj"
                :allUserArr="allUserArr"
                :dataTestId="`${dataTestId}__project-collab-section`"
              />

              <hr color="#fff" class="mt-2 mb-3" />

              <ProjectComments
                :projectDetails="projectDetails"
                :allComments="allComments"
                :allUserObj="allUserObj"
                :dataTestId="`${dataTestId}__project-comment-section`"
              />
              <hr color="#fff" class="mt-2 mb-3" />
              <search-history
                :projectDetails="projectDetails"
                :allComments="allComments"
                :allUserObj="allUserObj"
                :dataTestId="`${dataTestId}__project-search-history-section'`"
              />
            </template>
          </div>
          <!-- end container -->
        </div>
      </v-navigation-drawer>
    </v-card>
  </v-col>
</template>

<script>
import EventBus from '@/EventBus';
import ProjectArchivedItemsSummary from './Widgets/ProjectArchivedItemsSummary';
import ProjectTags from './Widgets/ProjectTags';
import ProjectCollabList from './Widgets/ProjectCollabList';
import ProjectComments from './Widgets/ProjectComments';
import SearchHistory from './Widgets/SearchHistory.vue';
import { objectCompare } from '../../helpers/common';

export default {
  props: {
    setheight: Number,
    projectDetails: Object,
    allUserObj: Object,
    allUserArr: Array,
    dataReady: Boolean,
    allTags: Array,
    allComments: Array,
    getTagsAndComments: Function,
    dataTestId: String
  },
  components: {
    ProjectArchivedItemsSummary,
    ProjectTags,
    ProjectCollabList,
    ProjectComments,
    SearchHistory
  },
  data() {
    return {
      drawer: true,
      drawerWidth: 300,
      minify: false,
      companiesnameList: [
        'Company name',
        'Longer company name',
        'Small name',
        'Company name',
        'Longer company name',
        'Small name'
      ],
      openAddCollab: false,
      totalItemToggle: true,
      tagToggle: true,
      collabToggle: true,
      isSortByNameToggled: false,
      updateToggle: true,
      selectedSort: 'sortByName',
      collaboratorsList: [],
      height: '-1px'
    };
  },
  watch: {
    // eslint-disable-next-line
    dataReady(newVal, oldVal) {
      if (newVal) {
        this.setCollaborators();
        this.getTagsAndComments();
        // !IMPORTANT - original implementation below - will be done later
      }
    },
    isVaultItem(fullPath) {
      return fullPath?.includes('vault');
    },
    searchString() {
      if (
        this.searchString &&
        !objectCompare(JSON.parse(this.searchString), {})
      ) {
        this.addNewSearchHistory();
      }
    }
  },
  computed: {
    searchString() {
      return this.$route.fullPath?.includes('vault')
        ? this.$route.query.advanceSearchParams
        : this.$route.query.qs;
    }
  },
  methods: {
    /**
     * remove recent collab
     * @param {String} ele
     */
    removeFromRecent: function(ele) {
      const recentCollabDelete = {
        isOpen: true,
        value: ele
      };
      EventBus.$emit('OPEN_REMOVE_RECENT_DIALOGUE', recentCollabDelete);
    },
    // hide and display the navigation pan
    toggleLeftNavigationPan() {
      this.minify = !this.minify;
      EventBus.$emit('MINIFY_LEFT', this.minify);
    },
    // sort data by name
    handleSortSelectionByname() {
      this.isSortByNameToggled = !this.isSortByNameToggled;
      this.selectedSort = 'sortByName';
    },
    //sort data by user count
    handleSortSelectionByUserCount() {
      this.selectedSort = 'sortByUserCount';
    },
    // add collabrators
    setCollaborators() {
      this.collaboratorsList = [];
      if (!this.projectDetails || !this.allUserObj) {
        return;
      }
      let arrUser = [];
      let collaborators = this.projectDetails.collaborators;
      collaborators.forEach(collab => {
        let user = this.allUserObj[collab.toLowerCase()];
        if (user !== undefined) {
          arrUser.push(user);
        }
      });
      this.collaboratorsList = arrUser;
    },
    async addNewSearchHistory() {
      const projectId = this.$route.params?.projectId;
      try {
        await this.$services.project.addSearchHistory({
          projectId,
          queryString: encodeURIComponent(this.$route.fullPath)
        });
      } catch (err) {
        this.snackbar('error', err);
      }
    }
  },
  mounted() {
    let clientHeightIncrement = 100;
    this.drawerWidth = this.$el.clientWidth;
    EventBus.$emit('MINIFY_LEFT', this.minify);
    this.$nextTick(() => {
      EventBus.$emit(
        'LEFT_NAV_HEIGHT',
        document.getElementById('leftNav')?.clientHeight + clientHeightIncrement
      );
    });
  }
};
</script>

<style>
.v-skeleton-loader > div {
  margin-bottom: 10px;
}
.leftContentDrawerData h4 {
  font-size: 17px;
}
</style>

<style scoped lang="scss">
.item-count {
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
  text-align: left;
}
.content {
  padding-bottom: 25px;
  border-bottom: 1.5px solid #ffff;
}
.tag-container {
  display: inline-block;
  position: sticky;
}
.borderNone {
  border: none !important;
}
</style>

<style>
.slideUp-enter-active {
  transition: all 0.8s ease;
}
.slideUp-leave-active {
  transition: all 0.3s ease-in-out;
}
.slideUp-enter,
.slideUp-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}
</style>
